module.exports = __webpack_public_path__ + "static/media/press18.929a61fe.png";